import $ from "jquery";
import ScrollMagic from "ScrollMagic";
require("debug.addIndicators");


export default class Scroll {
  constructor() {}

  init() {
    const controller = new ScrollMagic.Controller();

    $(".js-trigger").each((i, el) => {
      const name = $(el).attr("id").split("_")[1];
      const triggerElement = `#js-trigger_${name}`;
      const targetId = `#js-trigger-target_${name}`;
      // console.log(targetId);

      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        reverse: true
      })
        .setClassToggle(targetId, "is-enter")
        // .addIndicators({name: `${name}`})
        .addTo(controller);
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Scroll.js